<template>
	<div class="carrier-page">
		<base-header class="pb-6 bg-light">
			<b-row align-v="center" class="py-4">
				<b-col cols="12" lg="6">
					<h6 class="h2 d-inline-block mb-0 text-dark">Carrier Admin</h6>
					&nbsp;
				</b-col>
				<b-col cols="12" lg="6" class="text-right">
					<nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
						<route-bread-crumb></route-bread-crumb>
					</nav>
				</b-col>
			</b-row>

			<div>
				<!-- START: LIST_CARRIERS -->
				<div class="accordion border-black-2" role="tablist">
					<!-- Name Table for Carriers Card -->
					<b-card no-body class="mb-0 border-non-radius">
						<b-card-header header-tag="header" class="p-0" role="tab">
							<base-button
								block
								type="primary"
								size="sm"
								class="border-non-radius text-left d-flex justify-content-between"
							>
								<div>Name</div>
								<base-button
                  data-cy="ota-carrier-reload-btn" 
                  @click="reloadButtonClick()" 
                  type="warning" 
                  class="vertical-dot-button" 
                  title="Reload"
                >
									<i class="fa fa-recycle"></i>
								</base-button>
							</base-button>
						</b-card-header>
					</b-card>

					<b-card v-if="carrierLoading" id="lists_carrier_card">
						<b-row class="text-md-center">
							<b-col md="12">
								<b-icon icon="three-dots" animation="cylon" font-scale="4"></b-icon>
							</b-col>
						</b-row>
					</b-card>

					<template v-else>
						<!-- START: NEW_CARRIER -->
						<b-card no-body class="mb-0 border-non-radius" id="new_carrier_card">
							<b-card-header header-tag="header" class="p-0 mb-0" role="tab">
								<base-button
									block
									v-b-toggle.accordion-0
									type="light"
									size="md"
									v-on:click="newCarrierClick = !newCarrierClick"
									class="border-non-radius text-dark text-left"
								>
									<i
										class="fas mr-1"
										v-bind:class="newCarrierClick ? 'fa-angle-down' : ' fa-angle-right'"
									></i
									>+ New Carrier
								</base-button>
							</b-card-header>
							<b-collapse id="accordion-0" accordion="'my-accordion3" role="tabpanel">
								<b-card-body>
									<b-tabs card>
										<b-tab title="Settings">
											<settings-tab
												:carrier="newCarrier"
												:parentOption="parentOption"
												:technologyOption="newTechnologyOption"
												:vendorOption="newVendorOption"
											></settings-tab>
										</b-tab>
										<!-- <b-tab title="Files">
											<files-tab
											:carrier="newCarrier"
											:efOptions="efOptions"
											:fileTypes="fileTypes"
											></files-tab>
										</b-tab>
										<b-tab title="ICCIDs">
											<iccids-tab
											:carrier="newCarrier"
											></iccids-tab>
										</b-tab> -->
									</b-tabs>
								</b-card-body>
							</b-collapse>
						</b-card>
						<!-- END: NEW_CARRIER -->

						<!-- START: EXISTING_CARRIERS -->
						<b-card
							v-for="(carrier, index) in carriers"
							:id="carrier.name + 'card'"
							no-body
							class="mb-0 border-non-radius carrier-page-exist"
							:key="carrier.name"
						>
							<b-card-header
								header-tag="header"
								class="p-0 d-flex align-items-center justify-content-between mb-0"
								role="tab"
								v-if="carrier.name !== ''"
							>
								<base-button
                  :data-cy="`ota-carrier-${carrier.name}-dropdown`"
									:disabled="!!carrier.disabled"
									v-b-toggle="'accordion-0' + index"
									type="light"
									block
									class="border-non-radius text-dark text-left d-flex justify-content-between"
									@click="setActiveCarrier(carrier.name)"
								>
									<div class="w-100" v-on:click="carrier.dropdown = !carrier.dropdown">
										<span v-if="!carrier.disabled" class="dynamic">
											<i class="fas mr-1 fa-angle-down"></i>
											<i class="fas mr-1 fa-angle-right ml-0"></i>
										</span>
										{{ carrier.display_name }} - 
										<b-badge v-if="carrier.parent === ''" pill variant="danger">
										 ADMIN
										</b-badge>
										<b-badge v-else pill variant="info">
										 {{ carrier.parent.toUpperCase() }}
										</b-badge>
									</div>

									<b-button
										class="vertical-dot-button"
										variant="primary"
										:id="carrier.name + 'popover'"
									>
										<b-icon icon="three-dots-vertical" class="font-16"></b-icon>
									</b-button>
									<b-popover
										:target="carrier.name + 'popover'"
										triggers="hover click blur"
										placement="topleft"
									>
										<b-row>
											<base-button
												type="link"
												v-on:click="
													disableCarrier_API({
														name: carrier.name,
														disable: !!carrier.disabled ? 0 : 1,
													})
												"
											>
												{{ !carrier.disabled ? "Disable" : "Enable" }}
											</base-button>
										</b-row>
										<b-row v-if="carrier.can_remove">
											<base-button
												type="link"
												v-on:click="deleteCarrier_API({name: carrier.name})"
											>
												Remove
											</base-button>
										</b-row>
									</b-popover>
								</base-button>
							</b-card-header>

							<b-collapse :id="'accordion-0' + index" accordion="'my-accordion3" role="tabpanel">
								<b-card-body 
              :data-cy="`ota-carrier-${carrier.name}-card-body`">
									<b-tabs>
										<b-tab title="Settings" >
											<settings-tab
												:carrier="carrier"
												:parentOption="parentOption"
												:technologyOption="newTechnologyOption"
												:vendorOption="newVendorOption"
                        :active_carrier="activeCarrier"
											></settings-tab>
										</b-tab>
										<b-tab title="Import" v-if="isPortalAdmin">
											<import-tab
												:carrier="carrier" 
                        :active_carrier="activeCarrier"
                      ></import-tab>
										</b-tab>
										<b-tab title="Ranges" v-if="isPortalAdmin">
											<iccids-tab
												:carrier="carrier"
												:is-portal-admin="isPortalAdmin"
                        :active_carrier="activeCarrier"
                      ></iccids-tab>
										</b-tab>
										<b-tab title="OTA Files">
											<files-tab
												:carrier="carrier"
												:efOptions="efOptions"
												:fileTypes="fileTypes"
                        :active_carrier="activeCarrier"
											></files-tab>
										</b-tab>
										<b-tab title="ESIM" v-if="isPortalAdmin && carrier.vendor==='esim'">
											<div>
												Not Implemented Yet!
											</div>
										</b-tab>
									</b-tabs>
								</b-card-body>
							</b-collapse>
						</b-card>
						<!-- END: EXISTING_CARRIERS -->
					</template>
				</div>
				<!-- END: LIST_CARRIERS -->
				<b-modal id="testInfoModal" title="File Info" size="sm" centered>
					<div class="input-group" v-if="info">
						<b-input-group>
							<template #prepend>
								<b-card-body class="pt-0 pb-0">
									<div>
										<Strong>API Name:</Strong>
										<span class="ml-1">{{ fileInfo.name || {} }}</span>
										<!-- <b-icon
											@click="copyToClipboard(fileInfo.name)"
											icon="file-earmark"
											variant="info"
											class="font-16 cursor-pointer ml-2 mr-2"
										></b-icon> -->
									</div>
									<div>
										<Strong>Size:</Strong>
										<span class="ml-1">{{ fileInfo.size }}</span>
									</div>
									<div>
										<Strong>Modified:</Strong>
										<span class="ml-1">{{ fileInfo.date.modified || {} }}</span>
									</div>
									<div>
										<Strong>Disabled:</Strong>
										<span class="ml-1">{{ fileInfo.disabled === 1 ? "Yes" : "No" }}</span>
									</div>
								</b-card-body>
							</template>
						</b-input-group>
					</div>
					<template #modal-footer>
						<div>
							<base-button type="primary" size="sm" class="float-right ml-2" v-on:click="closeModal">
								OK
							</base-button>
						</div>
					</template>
				</b-modal>
			</div>
		</base-header>
	</div>
</template>

<script>
import {reactive} from "vue";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import SettingsTab from "./CarrierSettings.vue";
import FilesTab from "./CarrierFiles.vue";
import IccidsTab from "./CarrierIccids.vue";
import ImportTab from "./CarrierImport.vue";
import otaDashboardService from "@/common/api-services/ota-dashboard-service";
import initService from "@/common/api-services/init-service";
import {validationMixin} from "vuelidate";
import {useVuelidate} from "@vuelidate/core";
import {ValidateEach} from "@vuelidate/components";
import {minLength, minValue, required} from "@vuelidate/validators";
import swal from "sweetalert2";
import Toast from "../../../Components/Toast.vue";
import VueClipboard from "vue-clipboard2";
import Vue from "vue";

export default {
	components: {
		RouteBreadCrumb,
		ValidateEach,
		SettingsTab,
		FilesTab,
		IccidsTab,
		ImportTab
	},
	name: "otaCarrier",
	setup() {
		const rules = {
			start: {
				required,
				minLength: minLength(19),
				number: true,
			},
			end: {
				required,
				minLength: minLength(19),
				number: true,
			},
		};
		const iccIdCollection = reactive({exists: [], item: {iccids: []}});
		const v = useVuelidate();
		return {rules, iccIdCollection, v};
	},

	data() {
		return {
			mixins: [validationMixin],
			carrierLoading: false,
			dirty: [],
			carriers: null,

			newCarrier: {
				parent: "",
				display_name: "",
				flags: {
					httpota: false,
					smsota: false,
					force_smsota: false,
				},
				technology: "",
				vendor: "",
				iccids: [],
				files: [
					{
						name: "",
						changed: "0",
					},
				],
				type: "carriers",
				method: "",
			},
			carrierToSend: {
				parent: "",
				display_name: "",
				flags: {
					httpota: false,
					smsota: false,
					force_smsota: false,
				},
				technology: "",
				vendor: "",
				iccids: [
					{
						start: "",
						end: "",
					},
				],
				files: [
					{
						display_name: "",
						name: "",
						changed: "",
						type: "",
						default: false,
						data: "",
						add: "",
						disable: false,
					},
				],
				type: "carriers",
				method: "",
			},
			showModal: false,
			showEditModal: false,
			showAddModal: false,
			showAddModalForNewCarrier: false,
			info: false,
			getNewFiles: false,
			file: {
				display_name: "",
				default: false,
				type: "",
				data: "",
				change: 0,
				add: 0,
			},
			efOptions: null,
			fileInfo: null,
			newCarrierClick: false,

			fileTypes: {},

			///https://ota.dccllc.net/ota/api/user/check and res.user.carrier.name [display_name]
			parentOption: [{value: "none", text: "None"}],

			///https://ota.dccllc.net/ota/api/user/check and res.user.carrier.technology
			newTechnologyOption: [
			],

			///https://ota.dccllc.net/ota/api/user/check and res.user.carrier.vendor
			//comes from https://ota.dccllc.net/ota/js/general.js
			newVendorOption: [
			],
			// userInfo: []
			backupCarrier: [],

			//ACCESS ROLES
			isAdministrator: false,
			isPortalAdmin: false,
			isOtaAdmin: false,
			activeCarrier:''
		};
	},
	
	computed: {
		noAccess() {
			// Determine access based on menu link configuration
			let userRoles = initService.getUserRoles();
			let link = this.$store.getters["getLinkByLink"](this.$router.currentRoute.path);

			if (!link) {
				return true;
			} else {
				userRoles = userRoles.filter(role => link.roles.includes(role.toUpperCase()));
				return userRoles.length === 0;
			}
		}
	},
	mounted: function () {
		document.title = "OTA - Carrier Admin";

		Vue.use(VueClipboard);

		this.$root.$on("getCarrierList_API", () => {
			this.getCarrierList_API();
		});

		this.$root.$on("DisplayFileInfo", data => {
			// console.log(data)
			this.fileInfo = data;
			this.info = true;
			this.$bvModal.show("testInfoModal");
		});

		this.isPortalAdmin = initService.getPortalAdminRole();

		//don't do anything unless the user has access
		if (this.noAccess) {
			this.$router.push("/restricted").catch(() => {});
		} else {
			this.getCarrierList_API();
		}

	},
	methods: {

		setActiveCarrier(carrier_name) {
			//sets the active carrier on a tab
			this.activeCarrier = carrier_name;
		},

		reloadButtonClick() {
			this.getCarrierList_API();
			this.resetCarrier();
		},

		async getCarrierList_API() {
			this.parentOption = [{text: "None", value: ""}];
			this.carrierLoading = true;
			this.newCarrierClick = false;

			const data = JSON.stringify({add: 1, files: 1});
			await otaDashboardService
				.getCarriersList(data)
				.then((res) => {
					if (res.data.result) {
						res.data.result.carriers.map(async (carrier) => {
							if (carrier.parents === undefined || carrier.parents.length === 0) {
								carrier.parents = "";
							}
							if (carrier.hasOwnProperty("display_name") && carrier.display_name !== "") {
								this.parentOption.push({value: carrier.name, text: carrier.display_name});
							} else {
								carrier.parents = "";
								carrier.files = []
								this.newTechnologyOption = carrier.technology;
								carrier.technology = "none";
								carrier.vendor = "none";

								await otaDashboardService
									.getVendors()
									.then(res => {
										if (res.data.result) {
											this.newVendorOption = res.data.result.map(vendor => {
												if (vendor.display_name.toLowerCase() === "default") {
													return {value: "none", text: "None"};
												}
												return {value: vendor.name, text: vendor.display_name};
											});
										} else {
											throw new Error(res.data.error_string);
										}
									})
									.catch(err => {
										console.error(err);
									});
							}
						});
						this.setCarrierData(res.data.result.carriers);
						// console.log(res.data.result.files);
						this.fileTypes = res.data.result.files;
						this.efOptions = Object.entries(res.data.result.files).map(e => e[0]);
					} else {
						throw new Error(res.data.error_string);
					}

					this.carrierLoading = false;
				})
				.catch(err => {
					this.carrierLoading = false;
					console.error(err);
				});
			this.carrierLoading = false;
		},

		disableCarrier_API(data) {
			if (data.disable === 1) {
				swal.fire({
					title: `Disable carrier`,
					text: `This will disable the carrier '${data.name}' and any logins associated with it. Do you want to continue?`,
					showCloseButton: true,
					showCancelButton: true,
					confirmButtonText: "Ok",
					cancelButtonText: "Cancel",
					customClass: {
						cancelButton: 'order-1 mr-3',
						confirmButton: 'btn btn-danger order-2',
					},
				}).then(result => {
					if (result.isConfirmed) {
						otaDashboardService
							.disableCarrier(data)
							.then(res => {
								if (res && res.data.status) {
									this.$toast.success({
										component: Toast,
										props: {
											subtitle: "PASS:",
											description:
												"Carrier disabled successfully. Any logins associated with this carrier have been disabled.",
										},
									});
									this.getCarrierList_API();
								} else {
									this.$toast.error(res.data.error_string);
								}
							})
							.catch(err => {
								throw err;
							});
					}
				});
			} else {
				otaDashboardService.disableCarrier(data).then(res => {
					if (res && res.data.status) {
						this.getCarrierList_API();
					} else {
						this.$toast.error(res.data.error_string);
					}
				});
			}
		},

		deleteCarrier_API(data) {
			swal.fire({
				title: `Remove carrier`,
				text: `This will remove the carrier '${data.name}' including any active tokens. This action is irreversible. Do you want to continue?`,
				showCloseButton: true,
				showCancelButton: true,
				confirmButtonText: "Ok",
				cancelButtonText: "Cancel",
				customClass: {
						cancelButton: 'order-1 mr-3',
						confirmButton: 'btn btn-danger order-2',
				},
			}).then(result => {
				if (result.isConfirmed) {
					otaDashboardService
						.removeCarrier(data)
						.then(res => {
							if (res && res.data.status) {
								this.$toast.success({
									component: Toast,
									props: {
										subtitle: "PASS:",
										description: `Carrier ${
											data.display_name ? data.display_name : data.name
										} has been deleted successfully`,
									},
								});
								this.getCarrierList_API();
							} else {
								this.$toast.error(res.data.error_string);
							}
						})
						.catch(err => {
							throw err;
						});
				}
			});
		},

		closeModal() {
			this.$bvModal.hide("testInfoModal");
		},

		resetCarrier() {
			// console.log("resetCarrier fired");

			this.file = {
				display_name: "",
				default: false,
				type: "",
				data: "",
			};
			this.localCarrier = null;
			this.newCarrier = {
				parent: "",
				display_name: "",
				flags: {
					httpota: false,
					smsota: false,
					force_smsota: false,
				},
				technology: "",
				vendor: "",
				iccids: [
					{
						start: "",
						end: "",
					},
				],
				files: [
					{
						display_name: "",
						name: "",
						changed: "",
						type: "",
						default: false,
						data: "",
						add: "",
					},
				],
				type: "carriers",
				method: "",
			};
			this.iccIdCollection = reactive({exists: [], item: {iccids: []}});
		},

		setCarrierData(carriers) {
			this.backupCarrier = {};
			let default_val = "none";
			let default_parent = (carriers[0].parents[0] || "").toString();
			this.carriers = carriers.map(carrier => {
				carrier.files = this.objectToArray(carrier.files);
				carrier.dropdown = false;
				this.dirty[carrier.name] = false;

				//* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
				//Fix the carrierToSend values
				//* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
				//console.log('\n\ncarrier.name: ',carrier.name);

				//set vendor (as string)
				this.carrierToSend.vendor = carrier.vendor ? carrier.vendor.toString() : default_val;
				carrier.vendor = this.carrierToSend.vendor;
				//console.log('carrier.vendor: ',carrier.vendor);

				//set parent
				this.carrierToSend.parent =
					Array.isArray(carrier.parents) && carrier.parents.length > 0
						? carrier.parents[0].toString()
						: default_parent;
				//carrier.parents = this.carrierToSend.parent;
				carrier.parent = (carrier.parents || [])[0] || default_parent;

				//set tech
				this.carrierToSend.technology =
					Array.isArray(carrier.technology) && carrier.technology.length > 0
						? carrier.technology[0].toString()
						: default_val;
				carrier.technology = this.carrierToSend.technology;
				//console.log('carrier.technology: ',carrier.technology);

				//* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

				// console.log('carrier.flags.httpota: '+carrier.flags.httpota);
				// console.log('carrier.flags.force_smsota: '+carrier.flags.force_smsota);
				// console.log('carrier.flags.smsota: '+carrier.flags.smsota);

				carrier.flags.httpota = !!carrier.flags.httpota;
				carrier.flags.force_smsota = !!carrier.flags.force_smsota;
				carrier.flags.smsota = !!carrier.flags.smsota;

				// console.log('carrier.flags.httpota: '+carrier.flags.httpota);
				// console.log('carrier.flags.force_smsota: '+carrier.flags.force_smsota);
				// console.log('carrier.flags.smsota: '+carrier.flags.smsota);

				if (carrier.iccids) {
					let iccidsTemp = [];
					for (let index = 0; index < carrier.iccids.length; index++) {
						iccidsTemp.push({
							start: carrier.iccids[index][0],
							end: carrier.iccids[index][1],
						});
					}
					carrier.iccids = [];
					carrier.iccids = iccidsTemp;
				}

				//clone object
				this.backupCarrier[carrier.name] = JSON.parse(JSON.stringify(carrier));

				//clone object
				return JSON.parse(JSON.stringify(carrier));
			});

			this.newCarrier = this.carriers[0];
		},

		objectToArray(data) {
			const res = [];
			for (let key in data) {
				const el = data[key];
				for (const elKey in el) {
					el[elKey].type = key;
					el[elKey].efDisabled = true;
					el[elKey].changed = 0;
				}
				res.push(...el);
			}
			return res;
		},

		// Copy password
		copyToClipboard(token = "no-token") {
			console.log("copyToClipboard", token);
			this.$copyText(token)
				.then(() => {
					this.$toast.info("Message copied to clipboard");
				})
				.catch(() => {
					this.$toast.error("Failed to copy message");
				});
		},
	},
};
</script>
